import { Link } from "react-router-dom";
import { CONTACT, BRAND } from "@/lib/config";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-baseline gap-2">
            <span className="h-display text-4xl text-white">KK</span>
            <span className="h-display text-4xl text-blue-400">Associates</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-sm">
            {BRAND.tagline}. Trusted advisors to individuals, MSMEs, startups and NRIs across {BRAND.city} and beyond.
          </p>
          <div className="mt-6 space-y-3 text-sm text-slate-300">
            <div className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-blue-400" /><span>{CONTACT.address}</span></div>
            <div className="flex items-center gap-3"><Phone size={16} className="text-blue-400" /><a href={`tel:${CONTACT.phoneRaw}`} data-testid="footer-phone" className="hover:text-white transition-colors">{CONTACT.phone}</a></div>
            <div className="flex items-center gap-3"><Mail size={16} className="text-blue-400" /><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-white transition-colors">{CONTACT.email}</a></div>
            <div className="flex items-center gap-3"><Clock size={16} className="text-blue-400" /><span>{CONTACT.hours}</span></div>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-medium mb-4 text-sm uppercase tracking-widest">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
            <li><Link to="/industries" className="hover:text-white transition-colors">Industries</Link></li>
            <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-medium mb-4 text-sm uppercase tracking-widest">Popular Services</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services/gst-registration" className="hover:text-white transition-colors">GST Registration</Link></li>
            <li><Link to="/services/income-tax-return" className="hover:text-white transition-colors">Income Tax Return</Link></li>
            <li><Link to="/services/company-registration" className="hover:text-white transition-colors">Company Registration</Link></li>
            <li><Link to="/services/accounting-bookkeeping" className="hover:text-white transition-colors">Accounting</Link></li>
            <li><Link to="/services/virtual-cfo" className="hover:text-white transition-colors">Virtual CFO</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-medium mb-4 text-sm uppercase tracking-widest">Get in touch</h4>
          <p className="text-sm text-slate-400 mb-4">Book a free 15-min consultation with our senior advisors.</p>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="btn-hover inline-flex items-center rounded-full bg-white text-slate-900 px-5 py-2.5 text-sm font-medium hover:bg-blue-400 hover:text-slate-900"
          >
            Book Consultation
          </Link>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p className="tracking-wider uppercase">Rajkot • Gujarat • India</p>
        </div>
      </div>
    </footer>
  );
}
